import { Link } from 'react-router-dom';
import cn from 'clsx';

import type { ExtendedNavigationProps } from '../types';
import { useStyles } from './NavigationXs.style';
import { useDrawerStateAtom } from '../Drawer/atoms';
import { useScrollHook, SCROLL_DOWN } from '../../../hooks/useScrollHook';
import useVenueUrl from 'hooks/useVenueUrl/useVenueUrl';
import { MOBILE_HEADER_NAV_CLOSE } from '../../../utils/layoutsElements';

export const NavigationXs: React.FC<ExtendedNavigationProps> = ({
    eventHeaderLogoUrl,
    eventName,
}) => {
    const classes = useStyles();
    const { drawerState, setDrawerState } = useDrawerStateAtom();
    const burgerClass = cn(classes.burgerIcon, { openMenu: !!drawerState });
    const { scrollDirection } = useScrollHook();
    const baseUrl = useVenueUrl();
    const headerClass = cn(classes.header, classes.appToolsHeader, {
        [classes.hideHeader]: scrollDirection === SCROLL_DOWN && !drawerState,
    });

    return (
        <header className={headerClass}>
            <a
                id={MOBILE_HEADER_NAV_CLOSE}
                className={burgerClass}
                onClick={() => setDrawerState(!drawerState)}
            >
                <span />
            </a>
            <div className={classes.logo}>
                {eventHeaderLogoUrl ? (
                    <Link to={baseUrl}>
                        <img
                            src={eventHeaderLogoUrl}
                            alt={eventName}
                            className={classes.eventLogo}
                        />
                    </Link>
                ) : null}
            </div>
        </header>
    );
};
